module.exports = __webpack_public_path__ + "img/purple_small.968f46bc.png";